import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            <span className="logo-text">ELİT AYDIN PREFABRİK & KONTEYNER YAPI SİSTEMLERİ</span>
          </Link>

          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Ana Sayfa
            </Link>
            <Link 
              to="/hakkimizda" 
              className={`nav-link ${location.pathname === '/hakkimizda' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Hakkımızda
            </Link>
            <Link 
              to="/hizmetlerimiz" 
              className={`nav-link ${location.pathname === '/hizmetlerimiz' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Hizmetlerimiz
            </Link>
            <Link 
              to="/projelerimiz" 
              className={`nav-link ${location.pathname === '/projelerimiz' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Projelerimiz
            </Link>
            <Link 
              to="/iletisim" 
              className={`nav-link ${location.pathname === '/iletisim' ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              İletişim
            </Link>
          </nav>

          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

